import { render, staticRenderFns } from "./vehicletype.vue?vue&type=template&id=17dbb01f"
import script from "./vehicletype.vue?vue&type=script&lang=js"
export * from "./vehicletype.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports